import { heroLead, heroSideCards } from "@/mocks/home";

function HeroSideCard({ card }: { card: (typeof heroSideCards)[number] }) {
  return (
    <a
      href="#timeline"
      className="group flex flex-col sm:flex-row gap-4 rounded-lg border border-background-200 bg-background-100 overflow-hidden hover:border-primary-300 transition-colors"
    >
      <div className="w-full sm:w-[200px] h-[180px] sm:h-[150px] shrink-0 overflow-hidden">
        <img
          src={card.img}
          alt={card.title}
          title={`热点黑料 ${card.title}`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col justify-between flex-1 px-4 pb-4 sm:py-4 sm:pl-0 sm:pr-4">
        <div>
          <span className="inline-block text-[11px] font-label tracking-[0.16em] text-accent-700 bg-accent-100 rounded-full px-2.5 py-1">
            {card.kicker}
          </span>
          <h3 className="mt-2.5 font-heading text-base md:text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">
            {card.title}
          </h3>
          <p className="hidden sm:block mt-2 text-xs leading-relaxed text-foreground-500">{card.excerpt}</p>
        </div>
        <span className="mt-3 text-[11px] font-label text-foreground-400">{card.meta}</span>
      </div>
    </a>
  );
}

export default function HeroSection() {
  return (
    <section className="w-full px-4 md:px-8 pt-6 md:pt-10 pb-10 md:pb-16">
      <div className="max-w-[1360px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 md:gap-10 mb-6 md:mb-9">
          <div className="max-w-2xl animate-fade-up">
            <span className="inline-flex items-center gap-2 text-[11px] font-label tracking-[0.24em] text-primary-600">
              <i className="ri-bookmark-3-line" />
              本期封面 · 第 148 辑
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-[2.6rem] leading-[1.15] font-black text-foreground-950">
              先从时间线开始，
              <br className="hidden md:block" />
              再看清事件到底走向了哪里
            </h2>
          </div>
          <p className="md:max-w-sm text-sm leading-relaxed text-foreground-500 md:text-right">
            深挖热点事件背后的完整时间线，从起因到发酵全程还原，收录原文与背景资料，帮你理清黑料来龙去脉，看清事件全貌。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <a
            href="#timeline"
            className="group lg:col-span-7 relative rounded-lg overflow-hidden border border-background-200 min-h-[420px] md:min-h-[560px] flex items-end animate-fade-up"
          >
            <img
              src={heroLead.img}
              alt={heroLead.title}
              title={`热点黑料深挖 ${heroLead.title}`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-[1200ms] group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-transparent" />
            <div className="relative z-10 p-5 md:p-8 w-full">
              <span className="inline-flex items-center gap-1.5 text-[11px] font-label tracking-[0.18em] text-background-50 bg-primary-500 rounded-full px-3 py-1">
                <i className="ri-fire-line" />
                {heroLead.kicker}
              </span>
              <h3 className="mt-3 font-heading text-2xl md:text-[2.1rem] font-bold leading-snug text-white max-w-3xl">
                {heroLead.title}
              </h3>
              <p className="hidden md:block mt-3 text-sm leading-relaxed text-white/80 max-w-2xl">{heroLead.excerpt}</p>
              <div className="mt-4 md:mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-[11px] md:text-xs font-label text-white/75">
                <span className="flex items-center gap-1.5">
                  <i className="ri-timeline-view" />
                  {heroLead.meta}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line" />
                  {heroLead.readTime}
                </span>
                <span className="ml-auto inline-flex items-center gap-1 text-background-50 group-hover:gap-2.5 transition-all">
                  进入深挖
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          </a>

          <div className="lg:col-span-5 flex flex-col gap-5 md:gap-6">
            {heroSideCards.map((card) => (
              <HeroSideCard key={card.title} card={card} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}